import styled from '@emotion/styled';
import type { SerializedStyles } from '@emotion/react';

export const Container = styled.div<{ background: SerializedStyles | '' }>`
  position: relative;
  ${({ background }) => background}
`;
